<template>
  <div>
      <div class="extra-checkbox-warp title">
        <span class="">
          {{ data.name }}
        </span>

    <!-- v-model="ischeckbox"
          @change="checkboxChange" -->
        <checkbox
          shape="square"
          checked-color="#5bad70"
          v-model="isActive"
          @change="checkboxChange"
        ></checkbox>
      </div>
  </div>
</template>

<script>
import { Checkbox } from "vant";
import {getVal} from './util';

export default {
    props:['data','value','rules'],
    data(){
        return {
            isActive:false
        }
    },
    mounted(){
        if(Object.keys(this.value).length>0){
            this.isActive = true;
        }
    },
    methods:{
        checkboxChange(v){
            // must=1 时不允许取消勾选
            if(!v && this.data['extra_list'][0] && this.data['extra_list'][0].must === 1){
                this.isActive = true;
                return;
            }
            if(v){
                var val = getVal(this.data.name,this.data['extra_list'][0], this.data.code);
                // 从 rules 获取 default_count 或 min_number 作为勾选后的份数
                var rulesDtl = this.rules && this.rules['group_detail_rules'];
                var item0 = this.data['extra_list'][0];
                var itemCode = item0['extra_sku'] || item0['code'];
                var qty = 1;
                var maxNum = null;
                if (rulesDtl && Array.isArray(rulesDtl)) {
                    var ruleItem = rulesDtl.find(function(r) { return r['group_detail_code'] === itemCode; });
                    if (ruleItem) {
                        if (ruleItem['default_count'] !== undefined) {
                            qty = ruleItem['default_count'];
                        } else if (ruleItem['min_number'] !== undefined) {
                            qty = ruleItem['min_number'];
                        }
                        if (ruleItem['max_number'] !== undefined) {
                            maxNum = ruleItem['max_number'];
                        }
                    }
                }
                if (qty <= 0) qty = 1;
                if (maxNum !== null && qty > maxNum) qty = maxNum;
                val['qty'] = qty;
                this.$emit('input', val);
            }else{
                this.$emit('input',{});
            }
        }
    },
    components:{
        Checkbox
    }
}
</script>

<style lang="scss" scoped>
.extra-checkbox-warp {
  display: flex;
  align-content: center;
  justify-content: space-between;
}
</style>